module.exports = __webpack_public_path__ + "static/media/gtp-missions-icon-text.ce408d11.png";